import React from "react";
import { NewStartersUsersEditorContainer } from "./styled";
import NewStartersDataBuilder from "../data/NewStartersDataBuilder";

function NewStartersEditor() {
  return (
    <NewStartersUsersEditorContainer>
      <NewStartersDataBuilder />
    </NewStartersUsersEditorContainer>
  );
}

export default NewStartersEditor;
